import React from 'react';
import { connect } from 'react-redux';
import { Layout, PageHeader, Select, Table, Tabs } from 'antd';
import {
  approveRejectTickets,
  fetchTickets
} from '../../../redux/actions/trm/trmDashboard';
import style from './index.scss';
import { withRouter } from 'react-router-dom';
import { returnFraudUserAccessByResource } from '../../../util/TmFraudModuleFilter';
import {
  TM_FRAUD_SOURCE_IDS,
  trmResources
} from '../../../util/GlobalConstant';
import { dashboardColumns } from './columns';

const { TabPane } = Tabs;

/**
 * TicketsDashboard
 */
class TicketsDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      deselectedRows: [],
      defaultCurrent: 1,
      pageSize: 20,
      selectedRow: null,
      trainingDate: '',
      isFraud: false,
      isTMuser: false,
      isFraudPrevention: false,
      currentSourceIds: '',
      currentTab: ''
    };

    const columns = dashboardColumns({
      authentication: this.props.authentication,
      history: this.props.history,
      onAction: this.onAction
    });
    this.detectionColumns = columns.detectionColumns;
    this.preventionColumns = columns.preventionColumns;
  }

  getSourceId = (isTMuser, isFraud, isFraudPrevention) => {
    let sourceId = null;

    if (isTMuser || isFraud) {
      let ids = [];

      isTMuser && ids.push(TM_FRAUD_SOURCE_IDS.TM);
      isFraud && ids.push(TM_FRAUD_SOURCE_IDS.FRAUD);

      sourceId = ids.join(',');
    } else if (isFraudPrevention) {
      sourceId = TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID;
    }

    return sourceId;
  };

  componentDidMount() {
    const { isTMuser, isFraud, isFraudPrevention } =
      returnFraudUserAccessByResource(
        this.props.authentication,
        trmResources.APP_3_RESOURCE_UI_AMLS_COMMON_TICKET
      );
    const selectedTab = new URLSearchParams(this.props.location.search)?.get(
      'sourceId'
    );
    let tab = '';
    let sourceId = null;

    if (selectedTab && selectedTab === TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID) {
      tab = 'Prevention';
      sourceId = selectedTab;
    } else {
      tab =
        isTMuser || isFraud ? 'Detection' : isFraudPrevention && 'Prevention';
      sourceId = this.getSourceId(isTMuser, isFraud, isFraudPrevention);
    }

    this.setState({
      isTMuser,
      isFraud,
      isFraudPrevention,
      currentTab: tab,
      currentSourceIds: sourceId
    });

    if (sourceId) {
      this.props.dispatchFetchTicketsAPI({
        defaultCurrent: 0,
        pageSize: 20,
        sourceId
      });
    }
  }

  onAction = (payload) => {
    this.setState({ isLoading: true });
    this.props.dispatchApproveRejectAPI(payload);
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 2000);
  };

  onPaginationChange = (page, pageSize) => {
    this.setState({ defaultCurrent: page, pageSize });
    this.props.dispatchFetchTicketsAPI({
      defaultCurrent: page,
      pageSize: pageSize,
      sourceId: this.state.currentSourceIds
    });
  };

  getRowKeyFromRecord = (obj) => {
    return obj.id;
  };

  onDropDownFilterChange = (selectedValue) => {
    this.setState({
      currentSourceIds: selectedValue,
      defaultCurrent: 1,
      pageSize: 20
    });
    this.props.dispatchFetchTicketsAPI({
      defaultCurrent: 1,
      pageSize: 20,
      sourceId: selectedValue
    });
  };

  onTabChange = (selectedTab) => {
    const sourceId =
      selectedTab === 'Detection'
        ? this.getSourceId(
            this.state.isTMuser,
            this.state.isFraud,
            this.state.isFraudPrevention
          )
        : TM_FRAUD_SOURCE_IDS.FRAUD_PREV_ID;
    this.setState({
      currentTab: selectedTab,
      currentSourceIds: sourceId,
      defaultCurrent: 1,
      pageSize: 20
    });
    this.props.dispatchFetchTicketsAPI({
      defaultCurrent: 1,
      pageSize: 20,
      sourceId
    });
  };

  render() {
    const { defaultCurrent, pageSize } = this.state;

    const { trmDashboard = {} } = this.props || {};
    const { ticketsList = {} } = trmDashboard || {};
    const { data, error, isLoading } = ticketsList || {};
    let ticketsArray = [];
    if (!isLoading && !error && data) {
      ticketsArray = data;
    }
    const dropdownOptions = [
      {
        value: `${TM_FRAUD_SOURCE_IDS.TM},${TM_FRAUD_SOURCE_IDS.FRAUD}`,
        label: 'All'
      },
      { value: TM_FRAUD_SOURCE_IDS.TM, label: 'TM' },
      { value: TM_FRAUD_SOURCE_IDS.FRAUD, label: 'Fraud' }
    ];

    return (
      <Layout className="layout">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Tickets"
        />
        <Tabs
          style={{ background: 'white' }}
          activeKey={this.state.currentTab}
          onChange={this.onTabChange}
          tabBarStyle={{
            marginBottom: 0,
            paddingLeft: 30
          }}
          tabBarExtraContent={
            this.state.currentTab === 'Detection' &&
            this.state.isFraud &&
            this.state.isTMuser && (
              <Select
                options={dropdownOptions}
                style={{ width: '150px', marginRight: 24 }}
                defaultValue={dropdownOptions[0].value}
                onChange={(e) => this.onDropDownFilterChange(e)}
              />
            )
          }>
          {(this.state.isFraud || this.state.isTMuser) && (
            <TabPane tab="Detection" key="Detection" />
          )}
          {this.state.isFraudPrevention && (
            <TabPane tab="Prevention" key="Prevention" />
          )}
        </Tabs>
        <div
          style={{
            padding: 20,
            backgroundColor: 'C3CB',
            display: 'flex',
            flexDirection: 'column'
          }}>
          <div style={{ backgroundColor: 'white', padding: 20 }}>
            <div
              style={{
                backgroundColor: 'white',
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4
              }}>
              <Table
                className={style.TicketListingTable}
                loading={isLoading || this.state.isLoading}
                columns={
                  this.state.currentTab === 'Detection'
                    ? this.detectionColumns
                    : this.preventionColumns
                }
                bordered={false}
                rowKey={this.getRowKeyFromRecord}
                pagination={{
                  total: ticketsArray.length,
                  current: defaultCurrent,
                  onChange: this.onPaginationChange,
                  pageSize
                }}
                dataSource={ticketsArray}
              />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

/**
 *
 * @param state
 * @param ownProps
 * @returns {{}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard,
    authentication: state.authentication.data
  };
}

/**
 *
 * @param dispatch
 * @param ownProps
 * @returns {{}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatchFetchTicketsAPI: (payload) => {
      dispatch(fetchTickets(payload));
    },
    dispatchApproveRejectAPI: (payload) => {
      dispatch(approveRejectTickets(payload));
    }
  };
}

/**
 * connect ConfigureInstanceDashboard
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketsDashboard)
);
